module.exports = __webpack_public_path__ + "static/media/Tracking.80db9c20.svg";